interface SendMessageButtonProps {
  disabled: boolean;
  onClick: () => void;
}

const SendMessageButton: React.FC<SendMessageButtonProps> = (
  props: SendMessageButtonProps
) => {
  return (
    <button
      type="button"
      className="ios-send"
      disabled={props.disabled}
      onClick={() => {
        props.onClick();
      }}
      title="Send"
      aria-label="Send"
    >
      <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
        <path
          d="M8 13V3M3.5 7.5 8 3l4.5 4.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default SendMessageButton;
